import React, { Fragment, useMemo, useState } from 'react'
import { ChatThreadCreatorViewProps } from './ChatThreadCreator.types'
import Styles from './ChatThreadCreator.module.scss'
import Avatar from '@onepercentio/one-ui/components/Avatar'
import { useUser } from 'core/logic/user'
import OneText from '@onepercentio/one-ui/components/Text'
import { FigmaTypo } from 'containers/OneUIProvider/OneUIProvider.data'
import Input from '@onepercentio/one-ui/components/Input'
import { t, tO } from 'translate/i18n'
import Button from '@onepercentio/one-ui/components/Button'
import SharedStyles from '../ChatThread/ChatThread.module.scss'
import AdaptiveContainer from '@onepercentio/one-ui/components/AdaptiveContainer'
import Loader from '@onepercentio/one-ui/components/Loader'

/**
 * Creates a thread and uploads
 **/
export default function ChatThreadCreatorView({
  onPost,
  loading,
  error,
  focused: staticFocusState,
  onCancel,
  initialMessage = ""
}: ChatThreadCreatorViewProps) {
  const { profile, detail } = useUser()

  const [text, setText] = useState(initialMessage)
  const [_focused, setFocused] = useState(!!initialMessage)
  const focused = staticFocusState === undefined ? _focused : staticFocusState
  function clear() {
    setFocused(false)
    setText('')
  }

  const { lbl } = useMemo(() => {
    if (profile) return { lbl: tO('forum.post.actions.post') }
    else
      return {
        lbl: t('components.topBar.signIn'),
      }
  }, [profile])

  const [top, bottom] = useMemo(() => {
    if (focused) {
      return [
        <Fragment key='focused'>
          <div className={SharedStyles.row}>
            <Avatar
              name={profile?.name || ''}
              imgSrc={detail?.photoURL!}
              size={44}
            />
            <div>
              <OneText type={FigmaTypo.H4}>{profile?.name || tO('forum.post.loggedOutUser')} </OneText>
            </div>
          </div>
          <br />
        </Fragment>,
        <Fragment key='focused'>
          <div className={SharedStyles.row}>
            <Button
              variant='transparent'
              onClick={() => {
                if (onCancel) onCancel()
                if (text.trim()) {
                  const confirmation = window.confirm(
                    tO('forum.post.cancelConfirmation')
                  )
                  if (confirmation) clear()
                } else {
                  clear()
                }
              }}
              color='primary'>
              {tO('forum.post.actions.cancel')}
            </Button>
            <Button
              disabled={loading || text === ''}
              variant='filled'
              onClick={() => {
                onPost(text).then(() => {
                  clear()
                })
              }}
              color='primary'>
              {loading ? <Loader /> : lbl}
            </Button>
          </div>
        </Fragment>,
      ]
    } else {
      return [<Fragment key='empty' />, <Fragment key='empty' />]
    }
  }, [focused, text, loading, error])

  return (
    <>
      <div className={`${Styles.root} ${focused ? Styles.focused : ''}`}>
        <AdaptiveContainer direction='v'>{top}</AdaptiveContainer>
        <Input
          error={error ? t('generic.errorMsg') : undefined}
          disabled={loading}
          onFocus={() => setFocused(true)}
          onBlur={({ target: { value } }) => {
            if (!value.trim()) setFocused(false)
          }}
          onChange={({ target: { value } }) => setText(value)}
          value={text}
          placeholder={tO('forum.post.placeholder')}
          multiline={2}
        />
        <AdaptiveContainer direction='v'>{bottom}</AdaptiveContainer>
      </div>
    </>
  )
}
